import {
  FaBuilding,
  FaCalendar,
  FaChevronLeft,
  FaChevronRight,
  FaCircle,
  FaEllipsisV,
  FaExclamationCircle,
  FaHeart,
  FaLinkedin,
  FaMinus,
  FaMinusCircle,
  FaPlus,
  FaPlusCircle,
  FaRegClock,
  FaRegHeart,
  FaTag,
  FaTwitter
} from 'react-icons/fa';
import { GiCardboardBoxClosed } from 'react-icons/gi';
import { HiDocumentSearch, HiOutlineMinusCircle, HiOutlinePlusCircle } from 'react-icons/hi';
import {
  IoIosArrowUp,
  IoIosCloseCircle,
  IoMdCloseCircle,
  IoMdInformationCircle,
  IoMdInformationCircleOutline,
  IoMdSettings
} from 'react-icons/io';
import {
  MdAccountCircle,
  MdAdd,
  MdAddCircle,
  MdAddCircleOutline,
  MdAdminPanelSettings,
  MdArrowBack,
  MdArrowDropDown,
  MdArrowDropUp,
  MdArrowForward,
  MdAssignment,
  MdAssignmentLate,
  MdAssignmentTurnedIn,
  MdAttachFile,
  MdAutoGraph,
  MdBookmark,
  MdBookmarkBorder,
  MdBusiness,
  MdCall,
  MdCallMade,
  MdChatBubble,
  MdCheck,
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdCheckCircle,
  MdClear,
  MdClose,
  MdCloudUpload,
  MdCollections,
  MdDelete,
  MdDragHandle,
  MdEdit,
  MdError,
  MdErrorOutline,
  MdExpandLess,
  MdExpandMore,
  MdFileDownload,
  MdFileUpload,
  MdFilterList,
  MdGetApp,
  MdHeadsetMic,
  MdHelp,
  MdHome,
  MdImage,
  MdImportExport,
  MdInfo,
  MdInsertDriveFile,
  MdInsertLink,
  MdInventory2,
  MdLanguage,
  MdLibraryBooks,
  MdList,
  MdListAlt,
  MdLocalShipping,
  MdLock,
  MdMailOutline,
  MdMenu,
  MdModeComment,
  MdMoreHoriz,
  MdNavigateBefore,
  MdNavigateNext,
  MdNotifications,
  MdOutlineNoEncryption,
  MdPause,
  MdPeople,
  MdPersonAdd,
  MdRadioButtonChecked,
  MdRadioButtonUnchecked,
  MdReceipt,
  MdRemoveCircle,
  MdRemoveCircleOutline,
  MdSearch,
  MdShoppingCart,
  MdStar,
  MdStarBorder,
  MdSupportAgent,
  MdToday,
  MdUpdate,
  MdWarning,
  MdWork
} from 'react-icons/md';
import { TiFolderOpen, TiSocialSkypeOutline } from 'react-icons/ti';

import PropTypes from 'prop-types';

import Box from './assets/Box';
import FullPallet from './assets/FullPallet';
import GlobeIcon from './assets/GlobeIcon';
import Logout from './assets/Logout';

const IconsMap = {
  account: MdAccountCircle,
  add: MdAdd,
  addCircle: MdAddCircle,
  addCircleOutline: MdAddCircleOutline,
  addPerson: MdPersonAdd,
  arrowLeft: FaChevronLeft,
  adminPanel: MdAdminPanelSettings,
  assigment: MdAssignment,
  assignmentLate: MdAssignmentLate,
  assignmentTurnedIn: MdAssignmentTurnedIn,
  attachFile: MdAttachFile,
  autograph: MdAutoGraph,
  backArrow: MdArrowBack,
  bookmark: MdBookmark,
  bookmarkBorder: MdBookmarkBorder,
  box: Box,
  building: FaBuilding,
  calendar: FaCalendar,
  call: MdCall,
  callMadeMd: MdCallMade,
  chatBubble: MdChatBubble,
  check: MdCheck,
  checkbox: MdCheckBox,
  checkboxBlank: MdCheckBoxOutlineBlank,
  checked: MdRadioButtonChecked,
  chevronRight: FaChevronRight,
  circle: FaCircle,
  circleChecked: MdCheckCircle,
  circleClose: IoIosCloseCircle,
  clear: MdClear,
  close: MdClose,
  mdclose: IoMdCloseCircle,
  cloudUpload: MdCloudUpload,
  collections: MdCollections,
  comment: MdModeComment,
  cube: GiCardboardBoxClosed,
  decendingOrder: IoIosArrowUp,
  delete: MdDelete,
  document: MdInsertDriveFile,
  documentSearch: HiDocumentSearch,
  downArrow: MdExpandMore,
  download: MdFileDownload,
  dragHandle: MdDragHandle,
  dropdownArrow: MdArrowDropDown,
  dropUpArrow: MdArrowDropUp,
  edit: MdEdit,
  ellipsis: FaEllipsisV,
  email: MdMailOutline,
  error: MdError,
  errorOutline: MdErrorOutline,
  exclamationCircle: FaExclamationCircle,
  filledHeart: FaHeart,
  heart: FaRegHeart,
  filledStar: MdStar,
  filterlist: MdFilterList,
  fullPallet: FullPallet,
  fwdArrow: MdArrowForward,
  getApp: MdGetApp,
  graphRight: MdAutoGraph,
  headset: MdHeadsetMic,
  help: MdHelp,
  home: MdHome,
  image: MdImage,
  importExport: MdImportExport,
  info: MdInfo,
  infoCircle: IoMdInformationCircle,
  infoCircleOutline: IoMdInformationCircleOutline,
  insertLink: MdInsertLink,
  inventory2: MdInventory2,
  language: MdLanguage,
  libraryBook: MdLibraryBooks,
  linkedin: FaLinkedin,
  list: MdList,
  listIcon: MdListAlt,
  lock: MdLock,
  logout: Logout,
  mdBusiness: MdBusiness,
  mdClose: MdClose,
  mdWork: MdWork,
  menu: MdMenu,
  minus: FaMinus,
  minusCircle: HiOutlineMinusCircle,
  minusCircled: FaMinusCircle,
  moreHoriz: MdMoreHoriz,
  navigateBefore: MdNavigateBefore,
  navigateNext: MdNavigateNext,
  notifications: MdNotifications,
  pause: MdPause,
  people: MdPeople,
  plus: FaPlus,
  plusCircle: HiOutlinePlusCircle,
  plusCircled: FaPlusCircle,
  priceTag: FaTag,
  receipt: MdReceipt,
  removeCircle: MdRemoveCircle,
  removeCircleOutline: MdRemoveCircleOutline,
  search: MdSearch,
  settings: IoMdSettings,
  shippingTruck: MdLocalShipping,
  shoppingCart: MdShoppingCart,
  skypeOutline: TiSocialSkypeOutline,
  star: MdStarBorder,
  supportAgent: MdSupportAgent,
  sustainability: GlobeIcon,
  timer: FaRegClock,
  today: MdToday,
  twitterIcon: FaTwitter,
  unchecked: MdRadioButtonUnchecked,
  upArrow: MdExpandLess,
  update: MdUpdate,
  upload: MdFileUpload,
  warning: MdWarning,
  folderOpen: TiFolderOpen,
  noEncyption: MdOutlineNoEncryption
};

const CustomIcon = ({ type, className, size, ...props }) => {
  const Icon = IconsMap[type] || IconsMap.error;
  return <Icon className={className} size={size} focusable="false" {...props} />;
};

CustomIcon.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.string
};

CustomIcon.defaultProps = {
  className: '',
  size: ''
};

export default CustomIcon;
